import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './PackItemImage.scss';

export default class ItemImageOverlay extends Component {
	static propTypes = {
		show: PropTypes.bool.isRequired,
		imageUrl: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
	};

	render() {
		const { show, imageUrl, name } = this.props;

		return (
			show &&
			<div className="ItemImageOverlay">
				<div className="ItemImageOverlay-content">
					<img src={imageUrl} alt={name} />
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/PackItemImage/ItemImageOverlay.js